/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import React from 'react'
import { EXTRA_UNION_EUROPE, IDENTITY_DOCUMENT_TYPE_PATENTE, ITALIANA, RICHIESTA_RINNOVO } from '../../ClientPage/constants/ClientPageConstants';
import { getTemporaryDocumentsLabel } from '../../ClientPage/service/ClientPageServices'

import Bloc from './Bloc'
import Field from './Field'

export default function IdentityDocumentsBloc({ configuration, values, tunnelData }) {

    const { identityDocuments } = configuration;

    return <Bloc hide={!identityDocuments} name='My identity documents'>
        <Field
            name={'CitizenshipIT'}
            hide={!identityDocuments?.includes('citizenshipSimplified')}
            value={values.identityDocuments.citizenshipSimplified?.label} />

        <Field
            name={'citizenshipExtended'}
            hide={!identityDocuments?.includes('citizenshipExtended') || values.identityDocuments.citizenshipSimplified?.value === ITALIANA}
            value={values.identityDocuments.citizenshipExtended?.label} />

        <Field
            name={'Identity document type'}
            hide={!identityDocuments?.includes('identityDocumentType')}
            value={values.identityDocuments.identityDocumentType?.label} />

        <Field
            name={'Identity document number'}
            hide={!identityDocuments?.includes('identityDocumentsNumber')}
            value={values.identityDocuments.identityDocumentsNumber} />


        <Field
            name={'Place of issue'}
            hide={!identityDocuments?.includes('documentPlaceOfIssue')}
            value={values.identityDocuments.documentPlaceOfIssue?.label ? values.identityDocuments.documentPlaceOfIssue.label : values.identityDocuments.documentPlaceOfIssue} />

        <Field
            name={'Date of issue'}
            hide={!identityDocuments?.includes('documentDateOfIssue')}
            value={values.identityDocuments.documentDateOfIssue} />

        <Field
            name={'Number of driving license'}
            hide={!identityDocuments?.includes('identityDocumentsDriverLicenseNumber') && !IDENTITY_DOCUMENT_TYPE_PATENTE.includes(values.identityDocuments.identityDocumentType?.value)}
            value={values.identityDocuments.identityDocumentsDriverLicenseNumber} />

        <Field
            name={'Permit, residence permit'}
            hide={!identityDocuments?.includes('residencePermitType') || values.identityDocuments.citizenshipSimplified?.value !== EXTRA_UNION_EUROPE}
            value={values.identityDocuments.residencePermitType?.label} />

        <Field
            name={'Temporary document'}
            hide={!identityDocuments?.includes('temporaryDocument') || values.identityDocuments.citizenshipSimplified?.value !== EXTRA_UNION_EUROPE}
            value={getTemporaryDocumentsLabel(tunnelData, values.identityDocuments.temporaryDocument)} />

        <Field
            name={'Expiry residence permit date'}
            hide={!identityDocuments?.includes('residencePermitExpiryDate') || values.identityDocuments.citizenshipSimplified?.value !== EXTRA_UNION_EUROPE
                                                                            || values.identityDocuments.temporaryDocument !== RICHIESTA_RINNOVO  }
            value={values.identityDocuments.residencePermitExpiryDate} />

    </Bloc>

}